import React from "react";

function Footer(props) {
  return (
    <footer className="footer overHidden hidden-sm-screen d-lg-block force-show">
      <div className="mt-2 text-center">
        ©{new Date().getFullYear().toString()} Posti Messaging
      </div>
      <div className="version">Version: {window.NTT && window.NTT.version}</div>
    </footer>
  );
}

export { Footer };
